export const IMAGE_MIME_TYPE_REGEXP = /^image\/.*$/;

export const PDF_MIME_TYPE = 'application/pdf';
